<template>
  <div>
    <el-dialog :title="titleName" class="dialogClass" width="55%" :visible.sync="dialogFormVisible">
      <el-form :model="form" :rules="rules" ref="ruleForm">

        <el-row>
          <el-col :span="12">
            <el-form-item label="上级菜单" :label-width="formLabelWidth">
              <el-input v-model="form.parentName" autocomplete="off" :disabled="parentNameBool"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="菜单名称" :label-width="formLabelWidth" :required="true" prop="name">
              <el-input v-model="form.name" autocomplete="off" :disabled="isCanEditItem"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24" style="text-align: left">
            <el-form-item label="菜单类型" :label-width="formLabelWidth" :required="true" prop="type">
              <el-radio v-model="form.type" :label="0" :disabled="isCanEditItem">目录</el-radio>
              <el-radio v-model="form.type" :label="1" :disabled="isCanEditItem">菜单</el-radio>
              <el-radio v-model="form.type" :label="2" :disabled="isCanEditItem">按钮</el-radio>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="链接地址" :label-width="formLabelWidth">
              <el-input v-model="form.url" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="权限标识" :label-width="formLabelWidth">
              <el-input v-model="form.perms" autocomplete="off" :disabled="isCanEditItem"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="排列序号" :label-width="formLabelWidth" :required="true" prop="orderNum">
              <el-input-number v-model="form.orderNum" style="width: 100%" controls-position="right" :min="1" :max="100"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="菜单图标" :label-width="formLabelWidth">
              <el-input v-model="form.icon" v-on:click.native="selectIcon"
                        autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="dialogFormVisible = false">取 消</el-button>
        <el-button size="mini" type="primary" @click="addAndUpdate('ruleForm')">确 定</el-button>
      </div>
    </el-dialog>
    <icon v-if="iconVisible" ref="icon" @handleSelectIcon="handleSelectIcon"></icon>
  </div>
</template>

<script>

  import Icon from './icon'

  export default {
    name: 'IconList',
    components: {
      Icon
    },
    data() {
      return {
        dialogFormVisible: true,
        iconVisible: false,
        parentNameBool: true,
        isCanEditItem: false,
        titleName: '',
        url: '',
        form: {
          menuId: '',
          appId: '',
          appCode: '',
          parentId: '',
          parentName: '',
          name: '',
          url: '',
          perms: '',
          type: 2,
          icon: '',
          orderNum: ''
        },
        rules: {
          name: [{required: true, message: '请输入菜单名称', trigger: 'blur'}],
          type: [{required: true, message: '请输入菜单类型', trigger: 'blur'}],
          orderNum: [{required: true, message: '请输入排列序号', trigger: 'blur'}]
        },
        formLabelWidth: '120px'
      };
    },
    methods: {
      int(menuId, name, status) {

        this.$refs['ruleForm'].resetFields();
        this.form.menuId = '';
        this.form.appId = '';
        this.form.appCode = '';
        this.form.parentId = menuId;
        this.form.parentName = name;
        this.form.name = '';
        this.form.url = '';
        this.form.perms = '';
        this.form.type = 2;
        this.form.icon = '';
        this.form.orderNum = '';
        this.isCanEditItem = false;
        this.dialogFormVisible = true;

        if (status == 1) {
          this.url = "/business/sys/menu/update";
          this.titleName = "菜单权限-修改";
          this.$httpTAG({
            url: this.$httpTAG.adornUrl('/business/sys/menu/view'),
            method: 'post',
            data: this.$httpTAG.adornData({
              'menuId': menuId
            })
          }).then(r => {
            this.form = r.data.data;
            if(this.form.parentId=='0'|| this.form.parentId == 0){
              this.isCanEditItem = true;
            }
          }).finally(r => {})
        } else if (status == 2) {
          this.url = "/business/sys/menu/save";
          this.titleName = "菜单权限-新增下级";
          this.form.parentId = menuId;
        }
      },
      selectIcon() {
        this.iconVisible = true;
        this.$nextTick(() => {
          this.$refs.icon.int();
        })
      },
      handleSelectIcon(classname){
        this.form.icon = classname;
      },
      addAndUpdate(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {

            this.$httpTAG({
              url: this.$httpTAG.adornUrl(this.url),
              method: 'post',
              data: this.$httpTAG.adornData({
                'menuId': this.form.menuId,
                'appId': this.form.appId,
                'appCode': this.form.appCode,
                'parentId': this.form.parentId,
                'parentName': this.form.parentName,
                'name': this.form.name,
                'url': this.form.url,
                'perms': this.form.perms,
                'type': this.form.type,
                'icon': this.form.icon,
                'orderNum': this.form.orderNum
              })
            }).then(res => {
              if (res.data.code == 0) {
                this.$notify({
                  title: '操作成功！',
                  type: 'success',
                  offset: 600
                });
                this.dialogFormVisible = false
                this.$emit("handleCurrentChange","1");
              } else {
                this.$message({ // 失败
                  type: 'fail',
                  message: res.data.msg
                })
              }
            })

          } else {
            console.log('error submit!!');
            return false;
          }
        });
      }
    }
  };
</script>

<style scoped>
  .dialogClass >>> .el-dialog__body {
    padding: 30px 85px 30px 20px;
  }
</style>
